import { render, staticRenderFns } from "./repair-case-distrubute.vue?vue&type=template&id=2a46255f&scoped=true"
import script from "./repair-case-distrubute.vue?vue&type=script&lang=ts"
export * from "./repair-case-distrubute.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a46255f",
  null
  
)

export default component.exports